export const extractImageRelativePathFromDOMString = (domString) => {
    const domStringHelper = new DOMParser().parseFromString(domString, 'text/html')
    const imagesFound = domStringHelper.querySelectorAll('img')

    let validImagePathFound = ''
    imagesFound.forEach(imageElement => {
        if (imageElement.attributes.src !== undefined) {
            validImagePathFound = imageElement.attributes.src.value
        }
    })

    return validImagePathFound
}

function toDegreesMinutesAndSeconds(coordinate) {
    var absolute = Math.abs(coordinate)
    var degrees = Math.floor(absolute)
    var minutesNotTruncated = (absolute - degrees) * 60
    var minutes = Math.floor(minutesNotTruncated)
    var seconds = Math.floor((minutesNotTruncated - minutes) * 60)

    if (degrees < 10) degrees = '0' + degrees
    if (minutes < 10) minutes = '0' + minutes
    if (seconds < 10) seconds = '0' + seconds

    return degrees + '°' + minutes + '′' + seconds + '″'
}

// https://stackoverflow.com/questions/37893131/how-to-convert-lat-long-from-decimal-degrees-to-dms-format/37893239#37893239
// But slightly adjusted to our UI needs
export const convertDMS = (lat, lng) => {
    var latitude = toDegreesMinutesAndSeconds(lat)
    var latitudeCardinal = lat >= 0 ? 'N' : 'S'

    var longitude = toDegreesMinutesAndSeconds(lng)
    var longitudeCardinal = lng >= 0 ? 'E' : 'W'

    return latitude + ' ' + latitudeCardinal + '\n' + longitude + ' ' + longitudeCardinal
}

// International SOS has 2 systems for medical rating and we use one which varies from 7-10, for simplicity and to avoid confusion
// we are going to reduce it to values from 1-4
export const getStandarisedInternationalSOSMedicalRiskRating = (InternationalSOSMedicalRiskRating) => {
    return InternationalSOSMedicalRiskRating > 0 ? InternationalSOSMedicalRiskRating -= 6 : 0
}